<template>
	<v-container>
		<!-- Card - select a lodging to check -->
		<div v-if="lodgingsOfPersons.length" class="mx-auto ">
			<div
				:class="{
					checkerLight: !$vuetify.theme.isDark,
					checkerDark: $vuetify.theme.isDark,
				}"
				class="text-left pt-2 pl-2 mb-3 "
				v-for="(lodging, i) in lodgings"
				:key="i"
				@click="() => openBottomSheet(lodging)"
			>
				<span class="mb-2">Establecimiento:</span>
				<h4>{{ lodging.place.name }}</h4>
				<br />
				<v-btn class="orange darken-3 py-2 pl-2 mt-2">
					<span class="white--text">{{ setSubtitle(lodging) }}. <br /> </span>
				</v-btn>
				<br />
				<span class="mb-2 caption">
					Info. adicional:
					<br />
					{{ lodging.group }} - {{ lodging.room }}
				</span>
				<div>
					<v-chip small v-if="lodging.hasCheckin" color="primary" class="mr-2 mb-2">
						Ingreso {{ historyIn(lodging) }}
						<v-icon>
							mdi-check-bold
						</v-icon>
					</v-chip>
					<v-chip small v-if="lodging.hasCheckout" color="primary" class="mr-2 mb-2">
						Salida {{ historyOut(lodging) }}
						<v-icon>
							mdi-check-bold
						</v-icon>
					</v-chip>
				</div>
			</div>
			Revise sus ingresos y salidas, al final de esta pantalla
		</div>
		<!-- Botton sheet - check in-out -->
		<v-bottom-sheet v-model="sheet" scrollable>
			<v-card>
				<v-card-text
					v-if="lodgingSelected"
					style="height: max-content; min-height: 300px; width: 100%; border-top: 3px solid gray;"
				>
					<div v-if="showPermissionText" style="height: 300px;overflow-y: auto">
						<permissionsText />
					</div>
					<div v-else>
						<geofence-person
							v-if="position && position.coords && lodgingSelected"
							id-map="7"
							:height-map="$vuetify.breakpoint.lgAndUp ? '140px' : '250px'"
							:place="lodgingSelected.place"
							:id-place="lodgingSelected.place._id"
							:lat="position.coords.latitude"
							:lon="position.coords.longitude"
							:setLocationFlag="setLocationFlag"
						/>
						<template v-if="!lodgingSelected.hasCheckin">
							<div class="caption my-2 text--secondary">
								¿Quiere ingresar la temperatura?
							</div>
							<v-text-field
								id="temperature"
								v-model="temperature"
								dense
								outlined
								filled
								label="Temperatura"
								placeholder="Ej: 30.5"
							></v-text-field>
							<template v-if="person.isPhoneVerified !== 2">
								<div class="caption my-2 text--secondary">
									Su telefono no esta validado, ingreselo aqui
								</div>
								<v-text-field
									id="phone"
									v-model="phone"
									dense
									outlined
									filled
									label="Telefono"
									placeholder="Ej: 12345678"
								></v-text-field>
							</template>
						</template>
						<div class="mb-4">
							<span class="caption">
								<v-icon color="warning ">mdi-alert</v-icon>
								<span class="orange--text">
									ADVERTENCIA
								</span>
								<br />
								Si no estas en el perimetro del lugar, deberá tomar una foto para
								poder hacer ingreso
							</span>
							<input
								class="my-4"
								id="image-up"
								type="file"
								accept="image/*"
								capture="camera"
								@change="setImage"
							/>
						</div>
						<div class="d-flex justify-end align-center mb-3">
							<v-btn
								:loading="loading"
								color="success"
								@click="submitCheckIn"
								v-if="
									(locationFlag && !lodgingSelected.hasCheckin) ||
										(image && !lodgingSelected.hasCheckin)
								"
							>
								MARCAR INGRESO
							</v-btn>
							<v-btn
								:loading="loading"
								color="success"
								@click="submitCheckOut"
								v-if="
									(locationFlag && lodgingSelected.hasCheckin) ||
										(image && lodgingSelected.hasCheckin)
								"
							>
								MARCAR SALIDA
							</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-bottom-sheet>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { setEarnedToday, findDay } from '@/utils/lodging/setSalary';
import moment from 'moment';
import { setToken, unSetToken } from '@/plugins/auth';

export default {
	components: {
		permissionsText: () => import('@/components/user/PermissionsTexts'),
		GeofencePerson: () => import('@/components/persons/GeofencePerson'),
	},
	data() {
		return {
			loading: false,
			showChecker: false,
			temperature: '',
			phone: '',
			sheet: false,
			lodgingSelected: null,
			image: null,
			token: null,
			showPermissionText: false,
			poly: null,
			locationFlag: false,
			position: null,
		};
	},
	computed: {
		/**
		 * lodgings - actividades a Hacer check in-out hoy
		 * @returns {array} lodgings
		 */
		lodgings() {
			const today = moment().format('YYYY-MM-DD');
			let items = this.lodgingsOfPersons.filter(
				lodging =>
					lodging.setHistories &&
					moment(today).isSameOrAfter(moment(lodging.start)) &&
					moment(today).isSameOrBefore(moment(lodging.end))
			);
			items = items.map(el => ({
				...el,
				hasCheckin: el.histories.some(
					his => his.in && moment(his.in).format('l') == moment().format('l')
				),
				hasCheckout: el.histories.some(
					his => his.out && moment(his.out).format('l') == moment().format('l')
				),
			}));
			return items;
		},
		...mapGetters({ lodgingsOfPersons: 'Lodging/lodgingsOfPersons', person: 'Person/person' }),
	},
	created() {
		// Obtenemos el token de la url si lo hay
		if (this.$route.params.token) {
			let data = this.$route.params.token;
			let buff = new Buffer(data, 'base64');
			this.token = buff.toString('ascii');
		}
	},
	methods: {
		/**
		 * Establecemos la ubicacion
		 * Si es satisfatoria llama al metodo submit
		 * Si es fallida llama al metodo setFailurePosition
		 */
		setGeolocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					this.setPosition,
					this.setFailurePosition,
					{
						maximumAge: 0,
						enableHighAccuracy: true,
					}
				);
			}
		},
		/**
		 * Submit check in-out
		 * @param {position} Ubicacion de la persona
		 */
		async submitCheckIn() {
			this.loading = true;
			const coords = [this.position.coords.latitude, this.position.coords.longitude];
			if (this.token) setToken(this.token);

			const history = new FormData();
			history.append(
				'history',
				JSON.stringify({
					checkIn: coords,
					in: moment(),
					phone: this.phone,
					temperature: this.temperature,
				})
			);
			if (this.image) history.append('image', this.image);
			await this.createHistory({
				lodgingId: this.lodgingSelected._id,
				idPerson: this.person._id,
				history,
			});
			this.closeBottomSheet();
			if (this.token) unSetToken();
			this.loading = false;
		},
		async submitCheckOut() {
			this.loading = true;
			const coords = [this.position.coords.latitude, this.position.coords.longitude];
			if (this.token) setToken(this.token);

			const now = moment();
			const foundHistory = this.lodgingSelected.histories.find(
				item => moment(now).format('L') === moment(item.in).format('L')
			);
			const history = new FormData();
			history.append(
				'history',
				JSON.stringify({
					checkOut: coords,
					out: now,
					earned: setEarnedToday(foundHistory.in, now, this.person),
					extra: this.handlerHours(foundHistory.in, now, this.person, 'extra'),
					delay: this.handlerHours(foundHistory.in, now, this.person, 'delay'),
				})
			);
			if (this.image) history.append('image', this.image);
			await this.updateHistory({
				lodgingId: this.lodgingSelected._id,
				idPerson: this.person._id,
				history,
			});
			this.closeBottomSheet();
			if (this.token) unSetToken();
			this.loading = false;
		},
		lodgingHistory(lodging) {
			const todayHistory = lodging.histories.find(history =>
				moment(history.in).isSame(moment(), 'day')
			);
			return todayHistory;
		},
		historyIn(lodging) {
			const history = this.lodgingHistory(lodging);
			const historyDate = moment(history.in).format('HH:mm');
			return historyDate;
		},
		historyOut(lodging) {
			const history = this.lodgingHistory(lodging);
			const historyDate = moment(history.out).format('HH:mm');
			return historyDate;
		},
		setPosition(position) {
			this.position = position;
		},
		setLocationFlag(location) {
			this.locationFlag = location;
		},
		/**
		 * LLamada si hubo un error al obtener la ubicacion
		 */
		setFailurePosition(error) {
			let message = '';
			switch (error.code) {
				case 1:
					message = 'Haz denegado el acceso a tu ubicación.';
					break;
				case 2:
					message = 'Error obteniendo la ubicación';
					break;
				case 3:
					message = 'El tiempo de espera por la ubicación ha pasado';
					break;
				default:
					message = 'Ha ocurrido un error inesperado';
					break;
			}
			if (error.code == 1) this.showPermissionText = true;
			this.snackbar({
				content: message,
				color: 'warning',
			});
		},
		/**
		 * Subtitle usado en el card de la actividad
		 */
		setSubtitle(lodging) {
			if (!lodging.hasCheckin) return 'Registrar INGRESO';
			if (lodging.hasCheckin && !lodging.hasCheckout) return 'Registrar SALIDA';
			if (lodging.hasCheckin && lodging.hasCheckout) return 'Ingreso y salida registrado';
		},
		/**
		 * Establecemos la imagen
		 */
		setImage(event) {
			this.image = event.target.files[0];
		},
		/**
		 * Abrir bottom sheet
		 * Si ya tiene check in-out no abre
		 * @param {object} item actividad seleccionada para hacer check in-out
		 */
		openBottomSheet(item) {
			if (item.hasCheckin && item.hasCheckout) return;
			this.lodgingSelected = item;
			this.setGeolocation();
			this.sheet = true;
		},
		/**
		 * Cerrar bottom sheet
		 * Reset form
		 */
		closeBottomSheet() {
			if (this.image) document.getElementById('image-up').value = '';
			this.showPermissionText = false;
			this.temperature = '';
			this.phone = '';
			this.image = null;
			this.lodgingSelected = null;
			this.sheet = false;
		},
		/**
		 * Establece las horas extras o faltantes
		 */
		handlerHours(start, end, person, type) {
			// Horas que le tocan a esa persona ese dia trabajar
			const hoursToWork = findDay(person);
			// obtiene las hora que trabajó hoy
			const durations = moment.duration(moment(end).diff(moment(start)));
			// Total de horas extras
			let lengthHours;
			if (type == 'extra') lengthHours = durations.asHours() - hoursToWork.asHours();
			else lengthHours = hoursToWork.asHours() - durations.asHours();
			const sign = Math.sign(lengthHours);
			if (sign === 1 || sign === 0) {
				return moment()
					.startOf('day')
					.add(lengthHours, 'hours')
					.format('HH:mm');
			}
			return '-';
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
		...mapActions({
			createHistory: 'Lodging/createHistory',
			updateHistory: 'Lodging/updateHistory',
		}),
	},
};
</script>

<style media="screen">
.checkerLight {
	background-color: #ffffffad;
	border: 1px solid gray;
}

.checkerDark {
	background-color: #06091dd6;
	border: 1px solid #3a3a3a;
	box-shadow: 0px 2px 7px -1px rgb(0 0 0 / 75%);
	border-radius: 8px;
}
</style>
